<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full-middle"
  >
    <template #header>添加盘点单</template>
    <template #content>
      <el-form
          :model="form"
          label-width="100px"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item
                prop="warehouseId"
                label="盘点仓"
                label-width="65px"
                :rules="[
                  $gjRequired('请选择盘点仓')
                ]"
            >
              <gj-warehouse-select
                  width="240px"
                  v-model="form.warehouseId"
                  noValid
                  @input="changeWarehouseId"
                  :fba="false"
              ></gj-warehouse-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                prop="memo"
                label="备注"
                label-width="40px"
            >
              <gj-input
                  v-model="form.memo"
                  width="360px"
              ></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin: 10px 0 12px 0;">
          <gj-button type="primary" @click="addProduct" :disabled="!isMeaningful(form.warehouseId)">添加产品</gj-button>
        </div>
        <gj-table
            :index="false"
            :columns="columns"
            :data="form.items"
            :offset-height="74"
        >
          <template v-slot:productInfo="{row}">
            <div>
              <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
            </div>
            <div>
              <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
            </div>
          </template>
          <template v-slot:op="{index}">
            <gj-button type="text" @click="remove(index)">删除</gj-button>
          </template>
        </gj-table>
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button
          type="primary"
          @click="reservation(0)"
          :loading="reservationLoading"
          :disabled="form.items.length === 0 || !isMeaningful(form.warehouseId)"
      >确定</gj-button>
      <gj-button
          type="primary"
          @click="reservation(1)"
          :loading="reservationLoading2"
          :disabled="form.items.length === 0 || !isMeaningful(form.warehouseId)"
      >开始盘点</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaningfulMixin, modalMixIn, responseMixin} from "@/minxins";
  import AppInventoryAddProduct from './inventory-add-product';
  import {saveStorageCheck} from "@/api/warehouse";
  import {ProductEnum} from "@/utils/options";

  export default {
    name: "add-inventory",
    mixins: [modalMixIn, formRuleMixin, isMeaningfulMixin, responseMixin],
    data() {
      return {
        form: {
          warehouseId: null,
          memo: null,
          items: []
        },
        columns: [
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '200px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', minWidth: '100px', align: 'right'},
          {id: 'goodProduct', header: '库存良品量', field: 'fulfillableQuantity', minWidth: '100px', align: 'right', summary: true},
          {id: 'defective', header: '库存次品量', field: 'unsellableQuantity', minWidth: '100px', align: 'right', summary: true},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '100px'},
        ],
        reservationLoading: false,
        reservationLoading2: false,
      }
    },
    methods: {
      changeWarehouseId() {
        this.form.items = [];
      },
      addProduct() {
        const modal = this.$gjCreate(AppInventoryAddProduct, {
          props: {
            warehouseId: this.form.warehouseId,
            hideSkuList: this.form.items.map(v => v.sku),
          },
          on: {
            addConfirm: (data) => {
              this.form.items.push(...data);
              modal.$gjDestroy();
            }
          }
        })
      },
      remove(index) {
        this.form.items.splice(index, 1);
      },
      reservation(state) {
        this.reservationLoading = state === 0;
        this.reservationLoading2 = state === 1;
        this.form.items.forEach(v => {
          v.currentQuantity = v.fulfillableQuantity;
          v.currentBadQuantity = v.unsellableQuantity;
        });
        saveStorageCheck(this.form)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
              this.$emit('after', state === 1 ? res.data : null)
            })
          }).complete(() => {
          this.reservationLoading = false;
          this.reservationLoading2 = false;
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
